import { Component, OnInit, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DateTimeService } from '../../shared/datetime/datetime.service';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { StateService } from '../../shared/state-management/state.service';
import { StatusEventSearchStateObject } from '../models/status-event-search-item'
import { TrackingService } from '../services/tracking.service';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { StatusEventsMasterGridComponent } from '../status-events-master-detail-grid/status-events-master-grid.component';


@Component({
    templateUrl: './tracking-search-status-events-result.component.html',
    styleUrls: ['./tracking-search-status-events-result.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, StatusEventsMasterGridComponent]
})

export class TrackingSearchStatusEventResultComponent implements AfterViewInit, OnInit {

    constructor(
        public dateTimeService: DateTimeService,
        private route: ActivatedRoute,
        private loadingPanelService: LoadingPanelService,
        private stateService: StateService,
        private trackingService: TrackingService) { }

        // @ViewChild(BizDataGridDirective, { static: true }) private datagrid: BizDataGridDirective;

        stateObject: StatusEventSearchStateObject;
        
        stateLoaded = false;
        readonly stateKey: string = 'tracking-search-status-event-result-state';

    ngOnInit() {
        this.route.params.subscribe((parms: any) => {
            const stateObject = this.stateService.getState(this.stateKey) as StatusEventSearchStateObject;
            if (stateObject) {
                // TODO: Is there a better way to compare two objects without comparing the object-reference?
                // This is fast but not scalable.The order of the properties must be the same using this method.
                const previousParms = JSON.stringify(stateObject.QueryParms);
                const currentParms = JSON.stringify(parms);
                this.stateLoaded = previousParms === currentParms;
            }

            if (this.stateLoaded) {
                this.stateObject = stateObject;
            }
            else {
                this.stateObject = new StatusEventSearchStateObject();
                this.stateObject.QueryParms = parms;
            }
        });
    }

    ngAfterViewInit(): void {
        if (!this.stateLoaded) {
            this.refresh();
        }
    }

    refresh() {
        this.loadingPanelService.showLoadingPanelDirect('Loading status events...');
        this.trackingService.searchStatusEvents(this.stateObject.QueryParms).then((result) => {
            if (result) {
                this.stateObject.SearchStatusEventItems = result;
                this.loadingPanelService.hideLoadingPanel();
            }
            else {
                this.loadingPanelService.hideLoadingPanel();
            }
        }).catch(() => { this.loadingPanelService.hideLoadingPanel(); });
    }

    selectionChanged(e: any) {
        this.stateObject.SelectedRows = e.selectedRowsData;
    }
}